import { render, staticRenderFns } from "./BtnEnviarParaAnalise.vue?vue&type=template&id=1d54bc86"
import script from "./BtnEnviarParaAnalise.vue?vue&type=script&lang=js"
export * from "./BtnEnviarParaAnalise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports